const EARTH_RADIUS_MILES = 3958.8

const toRadians = degrees => (degrees * Math.PI) / 180

// Straight-line (great-circle) distance between two lat/lng points, in miles.
export const haversineMiles = (lat1, lng1, lat2, lng2) => {
  const dLat = toRadians(lat2 - lat1)
  const dLng = toRadians(lng2 - lng1)
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLng / 2) ** 2
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return EARTH_RADIUS_MILES * c
}
